export const de = {
    yourOrder: 'Ihre Bestellung',
    welcome: 'Willkommen!',
    subtotal: 'Zwischensumme (inkl. MwSt.):',
    discount: 'Rabatt:',
    tax: 'MwSt.:',
    remainingPayment: 'Zu zahlen:',
    refundDue: 'Rückerstattung:',
    change: 'Rückgeld:',
    login: 'Mit Ihrem Microsoft-Konto anmelden',
    invalidTenant: 'Ungültiger Tenant',
    invalidTenantMessage: 'Dieser Tenant konnte nicht überprüft werden. Bitte prüfen Sie den Link oder wenden Sie sich an den Support.',
    missingTenant: 'Tenant-Parameter fehlt',
    missingTenantMessage: 'Bitte öffnen Sie die App mit einer URL wie:',
    backToSetup: 'Zurück zur Einrichtung',
    backToSetupQuestion: 'Möchten Sie zur Einrichtung zurückkehren?',
    resetApp: 'Display zurücksetzen',
    resetAppQuestion: 'Alle gespeicherten Einstellungen und Anmeldedaten auf diesem Gerät löschen?',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    selectEnvironment: 'Umgebung auswählen',
    selectCompany: 'Unternehmen auswählen',
    selectPosUnit: 'Kasse auswählen',
    environment: 'Umgebung:',
    company: 'Unternehmen:',
    posUnit: 'Kasse:',
    changeEnvironment: 'Umgebung ändern',
    changeCompany: 'Unternehmen ändern',
    changePosUnit: 'Kasse ändern',
    lineOrder: 'Zeilenreihenfolge:',
    newestFirst: 'Neueste zuerst',
    oldestFirst: 'Älteste zuerst',
    setInUrl: (setting) => `In der URL gesetzt (${setting}) — dort ändern.`,
    standbyAfterSale: 'Standby nach Verkauf:',
    seconds: 'Sekunden',
    displayUrl: 'Display-URL:',
    copyUrl: 'URL kopieren',
    copied: 'Kopiert',
    copyFailed: 'Kopieren fehlgeschlagen',
    autoConfirmPaused: 'Das Display startet erst automatisch, wenn Sie auf Bestätigen drücken.',
    switchAccount: 'Microsoft-Konto wechseln',
    clear: 'Zurücksetzen',
    urlSettingsTitle: 'Was in der URL gesetzt werden kann',
    urlTenant: 'Microsoft-Tenant-ID (erforderlich)',
    urlPreselect: 'Einrichtungsschritte vorbelegen',
    urlAutoConfirm: 'Diese Seite beim Start überspringen',
    urlLineOrder: 'newestFirst oder oldestFirst',
    urlStandbyDelay: 'Sekunden, die ein abgeschlossener Verkauf angezeigt bleibt, Standard 180',
    urlColors: '6-stellige Hex-Farbe ohne #, z. B. 75153b',
    urlLang: 'da Dänisch, de Deutsch, no Norwegisch, sonst Englisch',
    urlCrane: 'On-Premise-Modus',
    urlOnPremiseLogin: 'On-Premise-Anmeldung, zusammen mit environment und company',
    urlReset: 'Allein in der URL: löscht gespeicherte Einstellungen und Anmeldedaten auf diesem Gerät',
    holdToReturn: 'In der App 5 Sekunden lang irgendwo auf den Bildschirm drücken, um zur Einrichtung zurückzukehren.',
    missingTenantInUrl: 'Tenant fehlt in der URL. App mit ?tenant=<MS tenant id> öffnen.',
    fetchEnvironmentsFailed: 'Umgebungen dieses Tenants konnten nicht geladen werden, entweder wegen eines Netzwerkfehlers oder fehlender Berechtigungen.',
    fetchCompaniesFailed: 'Unternehmen dieses Tenants konnten nicht geladen werden, entweder wegen eines Netzwerkfehlers oder fehlender Berechtigungen.',
    fetchPosUnitsFailed: 'Kassen dieses Tenants konnten nicht geladen werden, entweder wegen eines Netzwerkfehlers oder fehlender Berechtigungen.',
    autoStartMissing: (settings) => `Autostart abgebrochen: in der URL fehlt ${settings}.`,
    autoStartNotFound: (setting, urlValue) => `Autostart abgebrochen: ${setting} '${urlValue}' aus der URL wurde nicht gefunden.`,
};
